import SearchInput from 'components/SearchInput'
import React from 'react'
export default function EventSearch({ handleSearch, search }) {
  return (
    <div style={{ marginLeft: 10, marginRight: 10, marginTop: 15 }}>
      <SearchInput
        placeholder="Search by keyword"
        width="100%"
        height="42px"
        background="white"
        setSearchValue={value => handleSearch(value)}
        // setSearchValue={handleSearchAndToggle}
        searchValue={search || ''}
        iconPosition={'prefix'}
        borderLess={true}
        boxShadow={' 0px 4px 5px -3px rgba(0, 0, 0, 0.1)'}
        borderRadius={0}
      />
    </div>
  )
}
